/**
 * Each contract's balance in Ejar's own figures, as the engine last read it (GET /api/ejar/contract-balances -
 * the engine's saved copy, no call to Ejar). Monthly management shows it for DAILY contracts (owner, 26 Sep
 * 2026: "the daily amount straight from Ejar") - Yelo computes only the monthly ones.
 *
 * One read shared by every table on the page, kept 10 minutes. A failed read gives an empty map (the cells
 * then show '—'), never a figure.
 */
import { useEffect, useState } from 'react';
import { finesService } from './finesService';
import logger from '../utils/logger';

const TTL_MS = 10 * 60 * 1000;
let cached = null;          // { at, promise }

export const loadEjarBalances = (force = false) => {
    if (!force && cached && Date.now() - cached.at < TTL_MS) return cached.promise;
    const promise = finesService.ejarContractBalances()
        .then((r) => (r && r.contracts) || {})
        .catch((e) => {
            logger.warn('[contracts] Ejar balances could not be read; daily contracts show no balance', e);
            cached = null;  // try again next time
            return {};
        });
    cached = { at: Date.now(), promise };
    return promise;
};

/** The map { CONTRACT_NO: { balance, source, at, ... } }, or null while it loads. */
export const useEjarBalances = () => {
    const [map, setMap] = useState(null);
    useEffect(() => {
        let alive = true;
        loadEjarBalances().then((m) => { if (alive) setMap(m); });
        return () => { alive = false; };
    }, []);
    return map;
};
